module.exports = __webpack_public_path__ + "img/run-forrest-run.b7860b6e.png";